import { Button, ButtonTheme } from 'components/Button';
import { CodeField } from 'components/Field/CodeField';
import { ICONS } from 'components/Icon';
import * as Clipboard from 'expo-clipboard';
import { useAlert } from 'hooks/useAlert';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { AUTHENTICATE, RESET_AUTH_STEP } from 'store/actions';

import { Card } from 'components/Card';
import { styles } from './styles';
import { UserChip } from './UserChip';

export const Tfa: React.FC = () => {
  const dispatch = useDispatch();
  const [code, setCode] = useState<string>('');
  const alert = useAlert();

  const handleBack = () => dispatch(RESET_AUTH_STEP());

  const handleSubmit = useCallback(() => {
    if (code) {
      dispatch(AUTHENTICATE.request({ code }));
    }
  }, [code, dispatch]);

  const handlePaste = React.useCallback(async () => {
    const value = await Clipboard.getStringAsync();
    const cleanValue = value
      .split('')
      .filter((v) => Number.isInteger(parseInt(v, 10)))
      .join('')
      .slice(0, 6);
    if (cleanValue) {
      setCode(cleanValue);
    } else {
      alert({ text: 'Sorry, there was no code to paste' });
    }
  }, [alert]);

  useEffect(() => {
    if (code.length === 6) {
      handleSubmit();
    }
  }, [code, handleSubmit]);

  return (
    <>
      <UserChip />
      <Card
        label={
          'Enter the multi-factor authentication code\n' +
          'generated by your authenticator app'
        }
        style={styles.textFieldContainer}
        explanationLinkText="Paste code from clipboard"
        onExplanationLinkPress={handlePaste}
      >
        <CodeField
          onChange={setCode}
          externalValue={code}
          isOTP
          // Will re-focus field if an API error comes back
          autoFocusEveryRender
        />
      </Card>
      <View style={styles.buttonContainer}>
        <Button
          buttonTheme={ButtonTheme.secondary}
          onPress={handleBack}
          text="Back"
          marginRight
        />
        <Button
          disabled={code.length < 6}
          onPress={handleSubmit}
          text="Next"
          iconRight={ICONS.ChevronRightSolid}
          iconRightSize={15}
        />
      </View>
    </>
  );
};
